import {MenuRounded, CloseRounded, LightModeRounded, ModeNightRounded, ArrowForwardIosOutlined, ArrowBackIosOutlined, KeyboardArrowUpRounded, KeyboardArrowDownRounded, KeyboardArrowRightRounded, LabelRounded, HorizontalRuleRounded, AirlineSeatFlat, AirlineSeatIndividualSuite, NotificationsNoneRounded, FiberSmartRecordRounded, Accessible, Visibility, VisibilityOff, Download, CloudUploadRounded, SearchRounded, PhotoRounded, AddRounded, AccountBoxRounded, ListAltRounded, DeleteRounded, DoNotDisturbAltRounded, AspectRatioRounded, EditRounded, DraftsRounded, BlockRounded, CheckCircleOutlineRounded, KeyboardBackspaceRounded, LockRounded, MarkEmailReadRounded, PasswordRounded, HourglassEmptyRounded} from '@mui/icons-material'

import { adminUser, dashboard, enrollment, messages, settings, users } from '../assets';

// Create a union type of all icon components
type IconType =  | typeof MenuRounded | typeof CloseRounded | typeof LightModeRounded | typeof ModeNightRounded | typeof ArrowForwardIosOutlined | typeof ArrowBackIosOutlined | typeof KeyboardArrowUpRounded | typeof KeyboardArrowDownRounded | typeof KeyboardArrowRightRounded | typeof LabelRounded | typeof HorizontalRuleRounded | typeof AirlineSeatFlat | typeof AirlineSeatIndividualSuite | typeof NotificationsNoneRounded | typeof FiberSmartRecordRounded | typeof Accessible | typeof Visibility | typeof VisibilityOff | typeof Download | typeof CloudUploadRounded | typeof SearchRounded | typeof PhotoRounded | typeof AddRounded | typeof AccountBoxRounded | typeof ListAltRounded | typeof DeleteRounded | typeof DoNotDisturbAltRounded | typeof AspectRatioRounded | typeof EditRounded | typeof DraftsRounded | typeof BlockRounded | typeof CheckCircleOutlineRounded | typeof KeyboardBackspaceRounded | typeof LockRounded | typeof MarkEmailReadRounded | typeof PasswordRounded | typeof HourglassEmptyRounded;

interface NavigationItem {
    name: string;
    directory?: string;
    path?: string;
    image: string;
    icon?: IconType;  // Use JSX.Element here to allow React components
}

export const sideNavigation: NavigationItem[] = [
    { name: 'Dashboard', path: '/', image: dashboard },
    // { name: 'Users', directory: 'users', image: users, icon: KeyboardArrowRightRounded  },
    { name: 'Enrollment', directory: 'enrollment', image: enrollment, icon: KeyboardArrowRightRounded },
    { name: 'Messages', path: '/messages', image: messages },
    { name: 'Admins', directory: 'admins', image: adminUser, icon: KeyboardArrowRightRounded },
    { name: 'settings', path: '/settings', image: settings }
]

export const UsersTableHeader = [
    { name: 'Image'},
    { name: 'First name'},
    { name: 'lastName'},
    { name: 'username'},
    { name: 'email address'},
    { name: 'created'},
    { name: 'updated'},
    { name: 'Edit'},
]

export const UsersListHeader = [
    { name: 'image'},
    { name: 'first name'},
    { name: 'lastName'},
    { name: 'username'},
    { name: 'created'},
    { name: 'edit'},
]

export const EnrollmentTableHeader = [
    { name: 'Image'},
    { name: 'First name'},
    { name: 'lastName'},
    { name: 'sex'},
    { name: 'date'},
    { name: 'email address'},
    { name: 'phone number'},
    { name: 'Bachelor Degree'},
    { name: 'Resume'},
    { name: 'created'},
    { name: 'updated'},
    { name: 'Edit'},
]

export const EnrollmentListHeader = [
    { name: 'image'},
    { name: 'first name'},
    { name: 'lastName'},
    { name: 'sex'},
    { name: 'emailAddress'},
    { name: 'phoneNumber'},
    { name: 'resume'},
    { name: 'created'},
    { name: 'edit'},
]

export const UsersMainTableHeader = [
    {name: 'image'},
    {name: 'first name'},
    {name: 'middle name'},
    {name: 'last name'},
    {name: 'email address'},
    {name: 'username'},
    {name: 'phone'},
    {name: 'date of birth'},
    {name: 'sex'},
    {name: 'verified'},
    {name: 'created'},
    {name: 'updated'},
    {name: 'edit'},
]

export const genderOptions = [
    {name: "male"},
    {name: "female"},
]

export const ContactUsTableHeader = [
    { name: 'first name'},
    { name: 'lastName'},
    { name: 'email address'},
    { name: 'message'},
    { name: 'created'},
    { name: 'edit'},
]

export const AdminsTableHeader = [
    { name: 'Image'},
    { name: 'First name'},
    { name: 'lastName'},
    { name: 'username'},
    { name: 'email address'},
    { name: 'created'},
    { name: 'updated'},
    { name: 'Edit'},
]

export { MenuRounded, CloseRounded, LightModeRounded, ModeNightRounded, ArrowForwardIosOutlined, ArrowBackIosOutlined, KeyboardArrowUpRounded, KeyboardArrowDownRounded, KeyboardArrowRightRounded, LabelRounded, HorizontalRuleRounded, AirlineSeatFlat, AirlineSeatIndividualSuite, NotificationsNoneRounded, FiberSmartRecordRounded, Accessible, Visibility, VisibilityOff, Download, CloudUploadRounded, SearchRounded, PhotoRounded, AddRounded, AccountBoxRounded, ListAltRounded, DeleteRounded, DoNotDisturbAltRounded, AspectRatioRounded, EditRounded, DraftsRounded, BlockRounded, CheckCircleOutlineRounded, KeyboardBackspaceRounded, LockRounded, MarkEmailReadRounded, PasswordRounded, HourglassEmptyRounded,
}

